export const adminMetrics = [
  {
    id: 'students',
    label: 'Total Enrolled Students',
    value: '180',
    change: '+38 this month',
    trend: 'up',
    icon: 'ri-group-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-700',
    accent: 'border-l-4 border-l-accent-500',
  },
  {
    id: 'therapists',
    label: 'Active Faculties',
    value: '18',
    change: '+2 this month',
    trend: 'up',
    icon: 'ri-team-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-700',
    accent: 'border-l-4 border-l-primary-500',
  },
  {
    id: 'sessions',
    label: 'Student Attendance',
    value: '146',
    change: '-8% vs last week',
    trend: 'down',
    icon: 'ri-calendar-check-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-700',
    accent: 'border-l-4 border-l-secondary-500',
  },
  {
    id: 'pending',
    label: 'Staff Attendance',
    value: '17',
    change: '3 urgent',
    trend: 'warning',
    icon: 'ri-user-received-line',
    iconBg: 'bg-semantic-warning-bg',
    iconColor: 'text-semantic-warning',
    accent: 'border-l-4 border-l-semantic-warning',
  },
];

export const activityFeed = [
  {
    id: '1',
    type: 'lesson_plan',
    user: 'Emma Reyes',
    action: 'added a lesson plan for approval:',
    subject: 'Phonics — Week 3 Blends',
    time: '5 min ago',
    avatar: 'ER',
    avatarBg: 'bg-accent-500',
    icon: 'ri-file-list-3-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-700',
  },
  {
    id: '2',
    type: 'attendance',
    user: 'Preprimary — A',
    action: 'completed the students\' attendance for',
    subject: 'Morning Session',
    time: '18 min ago',
    avatar: 'PA',
    avatarBg: 'bg-primary-500',
    icon: 'ri-checkbox-circle-line',
    iconBg: 'bg-semantic-success-bg',
    iconColor: 'text-semantic-success',
  },
  {
    id: '3',
    type: 'daily_diary',
    user: 'Dr. Sarah Mitchell',
    action: 'submitted the daily diary for',
    subject: 'Primary — Grade 3',
    time: '42 min ago',
    avatar: 'SM',
    avatarBg: 'bg-secondary-500',
    icon: 'ri-book-open-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-700',
  },
  {
    id: '4',
    type: 'lesson_plan_approved',
    user: 'Admin (You)',
    action: 'approved lesson plan for',
    subject: 'Sensory Play — Group Activity',
    time: '1 hr ago',
    avatar: 'AD',
    avatarBg: 'bg-foreground-600',
    icon: 'ri-check-double-line',
    iconBg: 'bg-semantic-success-bg',
    iconColor: 'text-semantic-success',
  },
  {
    id: '5',
    type: 'attendance',
    user: 'Primary — B',
    action: 'marked attendance & flagged absence for',
    subject: 'Aarav Mehta',
    time: '2 hr ago',
    avatar: 'PB',
    avatarBg: 'bg-accent-500',
    icon: 'ri-alert-line',
    iconBg: 'bg-semantic-warning-bg',
    iconColor: 'text-semantic-warning',
  },
  {
    id: '6',
    type: 'daily_diary',
    user: 'James Okafor',
    action: 'submitted the daily diary for',
    subject: 'Preprimary — A',
    time: '3 hr ago',
    avatar: 'JO',
    avatarBg: 'bg-primary-500',
    icon: 'ri-book-open-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-700',
  },
  {
    id: '7',
    type: 'lesson_plan',
    user: 'Emma Reyes',
    action: 'updated lesson plan for',
    subject: 'Fine Motor — Tracing Skills',
    time: '4 hr ago',
    avatar: 'ER',
    avatarBg: 'bg-accent-500',
    icon: 'ri-file-edit-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-700',
  },
  {
    id: '8',
    type: 'pre_inspection',
    user: 'Ms. Emily Watson',
    action: 'logged pre-inspection for',
    subject: 'Aarav Mehta — Calm / Neutral 🟢',
    time: '55 min ago',
    avatar: 'EW',
    avatarBg: 'bg-green-500',
    icon: 'ri-clipboard-line',
    iconBg: 'bg-green-50',
    iconColor: 'text-green-600',
  },
  {
    id: '9',
    type: 'pre_inspection',
    user: 'Mr. James Okafor',
    action: 'logged pre-inspection for',
    subject: 'Zara Rodriguez — Tired / Lethargic 🔵',
    time: '42 min ago',
    avatar: 'JO',
    avatarBg: 'bg-blue-500',
    icon: 'ri-clipboard-line',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-600',
  },
  {
    id: '10',
    type: 'incident',
    user: 'Ms. Emma Reyes',
    action: 'recorded an incident for',
    subject: 'Ethan Williams — Behavioral, Moderate',
    time: '1 hr ago',
    avatar: 'ER',
    avatarBg: 'bg-red-500',
    icon: 'ri-alert-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600',
  },
  {
    id: '11',
    type: 'incident',
    user: 'Dr. Sarah Mitchell',
    action: 'recorded an incident for',
    subject: 'Liam Chen — Accident / Injury, Minor',
    time: '3 hr ago',
    avatar: 'SM',
    avatarBg: 'bg-red-500',
    icon: 'ri-alert-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600',
  },
  {
    id: '12',
    type: 'pre_inspection',
    user: 'Ms. Emma Reyes',
    action: 'logged pre-inspection for',
    subject: 'Sofia Nakamura — Happy / Content 🟢',
    time: '4 hr ago',
    avatar: 'ER',
    avatarBg: 'bg-green-500',
    icon: 'ri-clipboard-line',
    iconBg: 'bg-green-50',
    iconColor: 'text-green-600',
  },
  {
    id: '13',
    type: 'incident',
    user: 'Ms. Emma Reyes',
    action: 'recorded an incident for',
    subject: 'Mohammed Ayaan — Peer Conflict, Minor',
    time: '30 min ago',
    avatar: 'ER',
    avatarBg: 'bg-red-500',
    icon: 'ri-alert-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600',
  },
  {
    id: '14',
    type: 'incident',
    user: 'Ms. Emily Watson',
    action: 'recorded an incident for',
    subject: 'Aarav Mehta — Sensory Overload, Moderate',
    time: '15 min ago',
    avatar: 'EW',
    avatarBg: 'bg-red-500',
    icon: 'ri-alert-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600',
  },
];

export const recentStudents = [
  { id: 's1', studentId: 'STU-2024-001', name: 'Aarav Mehta',     className: 'Pre Primary - A', classTeacher: 'Ms. Emily Watson',    status: 'active',   avatar: 'AM' },
  { id: 's2', studentId: 'STU-2024-002', name: 'Priya Sharma',     className: 'Pre Primary - B', classTeacher: 'Ms. Jennifer Lee',    status: 'pending',  avatar: 'PS' },
  { id: 's3', studentId: 'STU-2024-003', name: 'Liam Chen',        className: 'Primary - A',      classTeacher: 'Dr. Sarah Mitchell', status: 'active',   avatar: 'LC' },
  { id: 's4', studentId: 'STU-2024-004', name: 'Zara Rodriguez',   className: 'Primary - B',      classTeacher: 'Mr. James Okafor',   status: 'active',   avatar: 'ZR' },
  { id: 's5', studentId: 'STU-2024-005', name: 'Ethan Williams',   className: 'Secondary - A',    classTeacher: 'Ms. Emma Reyes',     status: 'inactive', avatar: 'EW' },
  { id: 's6', studentId: 'STU-2024-006', name: 'Sofia Nakamura',   className: 'Pre Primary - A',  classTeacher: 'Ms. Emily Watson',    status: 'active',   avatar: 'SN' },
];

export const orgStats = [
  { label: 'Special Schools',      value: 14,  icon: 'ri-building-2-line',   color: 'text-accent-600' },
  { label: 'Therapy Centres',      value: 8,   icon: 'ri-hospital-line',      color: 'text-primary-600' },
  { label: 'Universities',         value: 3,   icon: 'ri-graduation-cap-line', color: 'text-secondary-600' },
  { label: 'Individual Therapists', value: 24, icon: 'ri-user-heart-line',    color: 'text-foreground-600' },
];

export const notifications = [
  { id: 'n1', title: 'New onboarding request',      description: '3 students pending coordinator approval.',        time: '5 min ago',   read: false, type: 'warning' as const },
  { id: 'n2', title: 'Assessment uploaded',          description: 'Priya Singh\'s Q2 assessment is ready to review.', time: '1 hr ago',    read: false, type: 'info' as const },
  { id: 'n3', title: 'Session completed',            description: 'Emma Reyes completed session with Aiden Brooks.', time: '2 hr ago',    read: true,  type: 'success' as const },
  { id: 'n4', title: 'Access role updated',          description: 'Carlos Rivera has been updated to Coordinator.',  time: '3 hr ago',    read: true,  type: 'info' as const },
];

export const adminUser = {
  name: 'Alexandra Reed',
  email: 'a.reed@xlplatform.edu',
  avatarInitials: 'AR',
};

export const weeklySessionData = [
  { day: 'Mon', sessions: 58, completed: 52 },
  { day: 'Tue', sessions: 72, completed: 68 },
  { day: 'Wed', sessions: 65, completed: 60 },
  { day: 'Thu', sessions: 80, completed: 75 },
  { day: 'Fri', sessions: 67, completed: 61 },
];

export const therapistUser = {
  name: 'Emma Reyes',
  email: 'e.reyes@xlplatform.edu',
  avatarInitials: 'ER',
};

export const teacherUser = {
  name: 'James Okafor',
  email: 'j.okafor@xlplatform.edu',
  avatarInitials: 'JO',
};

export const therapistMetricCards = [
  {
    id: 'caseload',
    label: 'Active Caseload',
    value: '12',
    change: '2 new this month',
    trend: 'up',
    icon: 'ri-group-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-700',
    accent: 'border-l-4 border-l-accent-500',
  },
  {
    id: 'sessions',
    label: 'Sessions This Week',
    value: '24',
    change: '18 completed',
    trend: 'neutral',
    icon: 'ri-calendar-check-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-700',
    accent: 'border-l-4 border-l-primary-500',
  },
  {
    id: 'assessments',
    label: 'Assessments Due',
    value: '4',
    change: 'This fortnight',
    trend: 'warning',
    icon: 'ri-file-chart-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-700',
    accent: 'border-l-4 border-l-secondary-500',
  },
  {
    id: 'notes',
    label: 'Session Notes',
    value: '6',
    change: 'Pending write-up',
    trend: 'warning',
    icon: 'ri-sticky-note-line',
    iconBg: 'bg-semantic-warning-bg',
    iconColor: 'text-semantic-warning',
    accent: 'border-l-4 border-l-semantic-warning',
  },
];

export const teacherMetricCards = [
  {
    id: 'students',
    label: 'My Students',
    value: '28',
    change: '3 new this term',
    trend: 'up',
    icon: 'ri-group-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-700',
    accent: 'border-l-4 border-l-accent-500',
  },
  {
    id: 'lessons',
    label: 'Lessons This Week',
    value: '18',
    change: '14 completed',
    trend: 'neutral',
    icon: 'ri-book-open-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-700',
    accent: 'border-l-4 border-l-primary-500',
  },
  {
    id: 'attendance',
    label: 'Avg Attendance',
    value: '94%',
    change: '+2% vs last week',
    trend: 'up',
    icon: 'ri-calendar-check-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-700',
    accent: 'border-l-4 border-l-secondary-500',
  },
  {
    id: 'pending',
    label: 'Pending Tasks',
    value: '5',
    change: 'Grading & reports',
    trend: 'warning',
    icon: 'ri-sticky-note-line',
    iconBg: 'bg-semantic-warning-bg',
    iconColor: 'text-semantic-warning',
    accent: 'border-l-4 border-l-semantic-warning',
  },
];

export const caseloadStudents = [
  { id: 'cs1', name: 'Aiden Brooks',     age: 11, domain: 'Behaviour Support',     school: 'Riverside Academy',       avatar: 'AB', nextSession: 'Today, 2:00 PM',  goalProgress: 68, status: 'active' as const },
  { id: 'cs2', name: 'Maya Chen',        age: 7,  domain: 'Occupational Therapy',   school: 'Eastview Therapy Centre', avatar: 'MC', nextSession: 'Tomorrow, 10:00 AM', goalProgress: 45, status: 'active' as const },
  { id: 'cs3', name: 'Liam Thompson',    age: 9,  domain: 'Speech & Language',      school: 'Sunrise Special School',  avatar: 'LT', nextSession: 'Today, 11:00 AM',  goalProgress: 82, status: 'active' as const },
  { id: 'cs4', name: 'Priya Singh',      age: 14, domain: 'Psychology',             school: 'Northfield University',   avatar: 'PS', nextSession: 'Wed, 1:30 PM',     goalProgress: 71, status: 'active' as const },
  { id: 'cs5', name: 'Oliver Nguyen',    age: 8,  domain: 'Speech & Language',      school: 'Sunrise Special School',  avatar: 'ON', nextSession: 'Fri, 9:00 AM',     goalProgress: 55, status: 'active' as const },
  { id: 'cs6', name: 'Zara Williams',    age: 6,  domain: 'Fine Motor Skills',      school: 'Eastview Therapy Centre', avatar: 'ZW', nextSession: 'Today, 3:30 PM',     goalProgress: 39, status: 'active' as const },
  { id: 'cs7', name: 'Ethan Davies',     age: 10, domain: 'Social Skills',          school: 'Riverside Academy',       avatar: 'ED', nextSession: 'Thu, 11:30 AM',    goalProgress: 61, status: 'active' as const },
  { id: 'cs8', name: 'Sofia Martinez',   age: 12, domain: 'Behaviour Support',     school: 'Sunrise Special School',  avatar: 'SM', nextSession: 'Tomorrow, 2:00 PM', goalProgress: 74, status: 'active' as const },
];

export const upcomingSessions = [
  { id: 'us1', student: 'Liam Thompson',  time: '11:00 AM – 12:00 PM', domain: 'Speech & Language',      type: '1:1 Therapy',   status: 'upcoming' as const, avatar: 'LT', avatarBg: 'bg-accent-500' },
  { id: 'us2', student: 'Aiden Brooks',   time: '2:00 PM – 3:00 PM',   domain: 'Behaviour Support',       type: '1:1 Therapy',   status: 'upcoming' as const, avatar: 'AB', avatarBg: 'bg-primary-500' },
  { id: 'us3', student: 'Zara Williams',  time: '3:30 PM – 4:30 PM',   domain: 'Fine Motor Skills',       type: 'Group Session', status: 'upcoming' as const, avatar: 'ZW', avatarBg: 'bg-secondary-500' },
  { id: 'us4', student: 'Maya Chen',      time: 'Tomorrow, 10:00 AM',  domain: 'Occupational Therapy',    type: 'Assessment',    status: 'upcoming' as const, avatar: 'MC', avatarBg: 'bg-accent-500' },
];

export const recentSessionNotes = [
  { id: 'sn1', student: 'Sofia Martinez',  date: 'Jul 26, 2026',  domain: 'Behaviour Support',     note: 'Sofia demonstrated improved self-regulation during transitions. Used visual schedule with 80% independence. Continuing to build on coping strategies.',    mood: 'positive' as const, duration: '60 min' },
  { id: 'sn2', student: 'Liam Thompson',   date: 'Jul 25, 2026',  domain: 'Speech & Language',     note: 'Articulation drills for /r/ and /s/ sounds progressing well. Liam produced /s/ in isolation with 90% accuracy. Introduced carrier phrases.',              mood: 'positive' as const, duration: '45 min' },
  { id: 'sn3', student: 'Ethan Davies',    date: 'Jul 25, 2026',  domain: 'Social Skills',         note: 'Peer interaction session — Ethan initiated conversation twice with prompting. Still requires support for turn-taking in group activities.',                 mood: 'neutral' as const, duration: '60 min' },
  { id: 'sn4', student: 'Aiden Brooks',    date: 'Jul 24, 2026',  domain: 'Behaviour Support',     note: 'Challenging session — Aiden was dysregulated after recess. Used co-regulation strategies and sensory break. Returned to task for final 15 minutes.',          mood: 'challenging' as const, duration: '60 min' },
  { id: 'sn5', student: 'Priya Singh',     date: 'Jul 23, 2026',  domain: 'Psychology',            note: 'CBT session focused on anxiety management. Priya identified 3 personal coping strategies and practiced deep breathing. Homework: thought journal.',            mood: 'positive' as const, duration: '50 min' },
];

export const teacherStudents = [
  { id: 'ts1', name: 'Aarav Mehta',       age: 6,  subject: 'Phonics',         school: 'Riverside Academy',       avatar: 'AM', nextClass: 'Today, 9:00 AM',  progress: 72, status: 'active' as const },
  { id: 'ts2', name: 'Priya Sharma',      age: 5,  subject: 'Numeracy',        school: 'Eastview Primary',        avatar: 'PS', nextClass: 'Today, 10:30 AM', progress: 65, status: 'active' as const },
  { id: 'ts3', name: 'Liam Chen',         age: 7,  subject: 'Literacy',        school: 'Riverside Academy',       avatar: 'LC', nextClass: 'Today, 11:00 AM', progress: 88, status: 'active' as const },
  { id: 'ts4', name: 'Zara Rodriguez',    age: 8,  subject: 'Science',         school: 'Northfield University',   avatar: 'ZR', nextClass: 'Tomorrow, 9:00 AM', progress: 74, status: 'active' as const },
  { id: 'ts5', name: 'Ethan Williams',    age: 9,  subject: 'Social Studies',  school: 'Riverside Academy',       avatar: 'EW', nextClass: 'Fri, 11:00 AM', progress: 59, status: 'active' as const },
  { id: 'ts6', name: 'Sofia Nakamura',    age: 6,  subject: 'Phonics',         school: 'Eastview Primary',        avatar: 'SN', nextClass: 'Today, 2:00 PM', progress: 81, status: 'active' as const },
  { id: 'ts7', name: 'Mohammed Ayaan',    age: 8,  subject: 'Literacy',        school: 'Riverside Academy',       avatar: 'MA', nextClass: 'Thu, 10:00 AM', progress: 47, status: 'active' as const },
  { id: 'ts8', name: 'Olivia Brown',      age: 7,  subject: 'Numeracy',        school: 'Eastview Primary',        avatar: 'OB', nextClass: 'Tomorrow, 1:30 PM', progress: 69, status: 'active' as const },
  { id: 'ts9',  name: 'Noah Kim',         age: 7,  subject: 'Literacy',        school: 'Riverside Academy',       avatar: 'NK', nextClass: 'Wed, 11:00 AM',  progress: 63, status: 'active' as const },
  { id: 'ts10', name: 'Ava Johnson',       age: 6,  subject: 'Phonics',         school: 'Eastview Primary',        avatar: 'AJ', nextClass: 'Tomorrow, 2:30 PM', progress: 78, status: 'active' as const },
  { id: 'ts11', name: 'Lucas Park',        age: 8,  subject: 'Science',         school: 'Northfield University',   avatar: 'LP', nextClass: 'Thu, 9:00 AM', progress: 55, status: 'active' as const },
  { id: 'ts12', name: 'Isla Garcia',       age: 9,  subject: 'Social Studies',  school: 'Riverside Academy',       avatar: 'IG', nextClass: 'Fri, 1:00 PM', progress: 82, status: 'active' as const },
];

export const teacherUpcomingLessons = [
  { id: 'ul1', student: 'Aarav Mehta',    time: '9:00 AM – 10:00 AM',  subject: 'Phonics — Blends',       type: 'Whole Class',   status: 'upcoming' as const, avatar: 'AM', avatarBg: 'bg-accent-500' },
  { id: 'ul2', student: 'Priya Sharma',   time: '10:30 AM – 11:30 AM', subject: 'Numeracy — Addition',     type: 'Small Group',   status: 'upcoming' as const, avatar: 'PS', avatarBg: 'bg-primary-500' },
  { id: 'ul3', student: 'Sofia Nakamura', time: '2:00 PM – 3:00 PM',   subject: 'Phonics — Digraphs',     type: '1:1 Support',   status: 'upcoming' as const, avatar: 'SN', avatarBg: 'bg-secondary-500' },
  { id: 'ul4', student: 'Liam Chen',      time: 'Tomorrow, 9:00 AM',   subject: 'Literacy — Comprehension', type: 'Whole Class', status: 'upcoming' as const, avatar: 'LC', avatarBg: 'bg-accent-500' },
];

export const teacherRecentNotes = [
  { id: 'rn1', student: 'Liam Chen',         date: 'Jul 26, 2026',  subject: 'Literacy',            note: 'Liam showed excellent comprehension during today\'s reading activity. Answered inferential questions with 85% accuracy. Continue challenging with Level 3 texts.',           mood: 'positive' as const, duration: '45 min' },
  { id: 'rn2', student: 'Aarav Mehta',       date: 'Jul 25, 2026',  subject: 'Phonics',             note: 'Aarav is blending CVC words independently. Struggles with /th/ and /sh/ digraphs. Added targeted worksheets for extra practice at home.',                                   mood: 'neutral' as const, duration: '60 min' },
  { id: 'rn3', student: 'Ethan Williams',    date: 'Jul 25, 2026',  subject: 'Social Studies',      note: 'Ethan participated well in group discussion about community helpers. Needs encouragement to write longer responses — currently gives one-word answers.',                   mood: 'neutral' as const, duration: '40 min' },
  { id: 'rn4', student: 'Zara Rodriguez',    date: 'Jul 24, 2026',  subject: 'Science',             note: 'Excellent engagement during the plant growth experiment. Zara made detailed observations and drew accurate diagrams. Natural curiosity shining through.',                     mood: 'positive' as const, duration: '50 min' },
  { id: 'rn5', student: 'Sofia Nakamura',    date: 'Jul 23, 2026',  subject: 'Phonics',             note: 'Sofia confidently read all sight words from the Term 3 list. Beginning to write simple sentences independently. Very proud of her progress!',                               mood: 'positive' as const, duration: '30 min' },
];

export const teacherNotifications = [
  { id: 'tn1', title: 'Lesson plan due',   description: 'Next week\'s lesson plan for Phonics needs submission.', time: '1 hr ago',   read: false, type: 'warning' as const },
  { id: 'tn2', title: 'Attendance marked',  description: 'Morning attendance for Primary B has been recorded.',      time: '3 hr ago',   read: false, type: 'info' as const },
  { id: 'tn3', title: 'New student',        description: 'Mohammed Ayaan has been enrolled in your class.',           time: 'Yesterday',  read: true,  type: 'info' as const },
  { id: 'tn4', title: 'Report approved',    description: 'Aarav Mehta\'s progress report has been approved.',          time: '2 days ago', read: true,  type: 'success' as const },
];

export const domainProgress = [
  { domain: 'Speech & Language',     currentScore: 72, baselineScore: 38, avgChange: '+8.5', color: 'bg-accent-500',   textColor: 'text-accent-700',   bgColor: 'bg-accent-100' },
  { domain: 'Occupational Therapy',  currentScore: 61, baselineScore: 34, avgChange: '+6.8', color: 'bg-primary-500',  textColor: 'text-primary-700',  bgColor: 'bg-primary-100' },
  { domain: 'Behaviour Support',     currentScore: 68, baselineScore: 30, avgChange: '+9.5', color: 'bg-secondary-500',textColor: 'text-secondary-700',bgColor: 'bg-secondary-100' },
  { domain: 'Psychology',            currentScore: 75, baselineScore: 42, avgChange: '+8.3', color: 'bg-semantic-success',  textColor: 'text-semantic-success',   bgColor: 'bg-semantic-success-bg' },
  { domain: 'Fine Motor Skills',     currentScore: 55, baselineScore: 26, avgChange: '+7.3', color: 'bg-semantic-warning',  textColor: 'text-semantic-warning',   bgColor: 'bg-semantic-warning-bg' },
  { domain: 'Social Skills',         currentScore: 58, baselineScore: 40, avgChange: '+4.5', color: 'bg-foreground-600',  textColor: 'text-foreground-600',     bgColor: 'bg-background-200' },
];

export const therapistNotifications = [
  { id: 'tn1', title: 'Assessment due',   description: 'Maya Chen\'s quarterly OT assessment is due this week.', time: '2 hr ago',   read: false, type: 'warning' as const },
  { id: 'tn2', title: 'Session completed', description: 'Aiden Brooks session notes are ready for review.',         time: '4 hr ago',   read: false, type: 'info' as const },
  { id: 'tn3', title: 'Caseload update',  description: 'New student assigned: Ethan Davies — Social Skills.',        time: 'Yesterday',  read: true,  type: 'info' as const },
  { id: 'tn4', title: 'Note approved',    description: 'Sofia Martinez\'s session note has been approved.',          time: '2 days ago', read: true,  type: 'success' as const },
];

export const teacherSubjectProgress = [
  { domain: 'Phonics',          currentScore: 78, baselineScore: 45, avgChange: '+8.3', color: 'bg-accent-500',   textColor: 'text-accent-700',   bgColor: 'bg-accent-100' },
  { domain: 'Numeracy',         currentScore: 65, baselineScore: 38, avgChange: '+6.8', color: 'bg-primary-500',  textColor: 'text-primary-700',  bgColor: 'bg-primary-100' },
  { domain: 'Literacy',         currentScore: 72, baselineScore: 40, avgChange: '+8.0', color: 'bg-secondary-500',textColor: 'text-secondary-700',bgColor: 'bg-secondary-100' },
  { domain: 'Science',          currentScore: 70, baselineScore: 48, avgChange: '+5.5', color: 'bg-semantic-success',  textColor: 'text-semantic-success',   bgColor: 'bg-semantic-success-bg' },
  { domain: 'Social Studies',   currentScore: 60, baselineScore: 35, avgChange: '+6.3', color: 'bg-semantic-warning',  textColor: 'text-semantic-warning',   bgColor: 'bg-semantic-warning-bg' },
  { domain: 'Art & Craft',      currentScore: 82, baselineScore: 55, avgChange: '+6.8', color: 'bg-foreground-600',  textColor: 'text-foreground-600',     bgColor: 'bg-background-200' },
];